// PageProjectBudget Component
/* eslint react/jsx-handler-names: 0 */

import React from 'react'
import HTML5Backend from 'react-dnd-html5-backend'
import { DragDropContext as dragDropContext } from 'react-dnd'
import async from 'async'
import _ from 'lodash'

import eventfilters from '../../../lib/eventfilters.jsx'
import SidebarActivity from '../../project/budget/sidebar_activity/sidebar_activity.jsx'
import SidebarColumnOptions from '../../project/budget/sidebar_column_options/sidebar_column_options.jsx'
import SidebarPurchaseOrder from '../../project/budget/sidebar_purchaseorder/sidebar_purchaseorder.jsx'
import DialogMail from '../../../common/dialog/dialog_email/dialog_email.jsx'
import DialogPurchaseOrderEdit from '../../../expense/dialog/dialog_purchaseorder_edit/dialog_purchaseorder_edit.jsx'
import PhaseFilter from '../../project/budget/phase_filter/phase_filter.jsx'
import PhaseHeader from '../../project/budget/phase_header/phase_header.jsx'
import PhaseList from '../../project/budget/phase_list/phase_list.jsx'
import PhaseAdd from '../../project/budget/phase_add/phase_add.jsx'
import PhaseFooter from '../../project/budget/phase_footer/phase_footer.jsx'
import PhaseToolbar from '../../project/budget/phase_toolbar/phase_toolbar.jsx'
import DragLayer from '../../common/draglayer/draglayer.jsx'
import BaseProjectView from '../../../project/page/base_projectview/base_projectview.jsx'
import app from '../../../app.jsx'
import BudgetUtil from '../../../lib/budgetutil.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import InvoiceUtil from '../../../lib/invoiceutil.js'
import currency from '../../../lib/currency.jsx'
import calculate from '../../../lib/calculation/budget'
import DialogConfirmDelete from '../../dialog/dialog_confirm_delete/dialog_confirm_delete.jsx'
import DialogPurchaseOrderOpen from '../../../expense/dialog/dialog_purchaseorder_open/dialog_purchaseorder_open.jsx'
import DialogPurchaseOrderComplete from '../../../expense/dialog/dialog_purchaseorder_complete/dialog_purchaseorder_complete.jsx'
import DialogInvoiceAddress from '../../../invoice/dialog/dialog_invoice_address/dialog_invoice_address.jsx'
import routes from '../../../../shared/routes.js'

@dragDropContext(HTML5Backend)
class PageProjectViewBudgetV2 extends BaseProjectView {
  constructor (props) {
    super(props, 'projectview-budgetv2', 'project', 'projectview-budgetv2')

    this.data = {
      project: this._getProjectFromCache(this.props.projectId),
      budget: null,
      items: null,
      rateCards: [],
      defaultRateCards: [],
      pageState: {
        type: 'grid',
        activeFilters: [],
        sort: 'title',
        sortAsc: true,
        columnOptions: this._createColumnOptions()
      },
      showedit: props.showedit ? props.showedit : '',
      stat: this._getOverviewStatFromCache(this.props.projectId),
      quickbookItems: [],
      emailSuggestions: []
    }

    this.state = {
      editActivity: null,
      editPurchaseOrder: null,
      showColumnOptions: false,
      loading: false
    }

    this.showOpen = true
    this._nextId = -1
    this._currentActivityId = null
    this._currentPhaseId = null
    this._currentPhase = null
    this._references = {
      refdialogMail: React.createRef(),
      budgetContent: React.createRef(),
      budgetItemAdd: React.createRef(),
      refDialogPurchaseOrderEdit: React.createRef(),
      uploadErrorDialog: React.createRef(),
      refDialogPurchaseOrderOpen: React.createRef(),
      refDialogInvoiceAddress: React.createRef(),
      refDialogPurchaseOrderComplete: React.createRef()
    }
    this.createCommonReference(this._references)
  }

  componentDidMount () {
    this._getData()
    this._initProjectEvents()
    this._initProjectCommonEvents()
  }

  componentWillUnmount () {
    this._releaseProjectEvents()
    this._releaseProjectCommonEvents()
  }

  render () {
    return (
      <>
        {this.renderDetailPageContent()}
        {this._renderConfirmDialog()}
      </>
    )
  }

  renderContent () {
    const { budget, pageState, project, rateCards } = this.data
    const { columnOptions, activeFilters } = pageState

    if (!budget) {
      return null
    }

    let totalBudget = 0
    const showTimeActivity =
      activeFilters.length === 0 || activeFilters.indexOf('time') >= 0
    const showExpenseActivity =
      activeFilters.length === 0 || activeFilters.indexOf('expense') >= 0

    if (budget.phases) {
      budget.phases.map(phase => {
        if (phase.items) {
          phase.items.forEach(item => {
            if (
              (showTimeActivity && item.type === 'time-activity') ||
              (showExpenseActivity && item.type === 'expense-activity')
            ) {
              totalBudget += parseFloat(item.total)
            }
          })
        }
      })
    }

    let icon = ''
    if (currency.getCurrency() === 'USD') {
      icon = 'dollar'
    } else if (currency.getCurrency() === 'GBP') {
      icon = 'pound'
    } else {
      icon = 'euro'
    }

    return (
      <div className='page-projectbudget'>
        <div className='phasecont'>
          <PhaseFilter
            filters={[
              {
                ident: 'expense',
                icon: icon,
                iconSize: icon === 'euro' ? '24' : '10'
              },
              {
                ident: 'time',
                icon: 'timer',
                iconSize: '24',
                className: 'timericon'
              }
            ]}
            active={pageState.activeFilters || []}
            onChange={this._onChangeFilter}
          />
          {this._renderPhaseToolbar()}
        </div>
        <PhaseHeader
          columnOptions={columnOptions}
          onColumnOptions={this._onColumnOptions}
        />
        <PhaseList
          phases={budget.phases}
          activeFilters={pageState.activeFilters}
          canEdit={project.status !== 'closed'}
          rateCards={rateCards}
          columnOptions={columnOptions}
          onChangeActivity={this._onChangeActivity}
          onSaveActivity={this._onSaveActivity}
          onKeyDownActivity={this._onKeyDownActivity}
          onDeleteActivity={this._onConfirmDeleteActivity}
          onEditActivity={this._onEditActivity}
          onAddActivity={this._onAddActivity}
          onClickEditActivity={this._onClickEditActivity}
          getItemPosition={this._getItemPosition}
          onMoveItem={this._onMoveItem}
          onSelectRatecard={this._onSelectRatecard}
          onChangePhase={this._onChangePhase}
          onSavePhase={this._onSavePhase}
          onKeyDownPhase={this._onKeyDownPhase}
          onDeletePhase={this._onConfirmDeletePhase}
          onToggleExpand={this._onToggleExpand}
          onClickEditPhase={this._onClickEditPhase}
          onChangePhaseStatus={this._onChangePhaseStatus}
          projectCloseDate={this.data.project.closeDate}
          onCopyPhase={this._onCopyPhase}
          onDropItem={this._onDropItem}
          onMovePhase={this._onMovePhase}
        />
        <DragLayer className='budgetlayer' />
        <div className='footercont'>
          <PhaseAdd onAddPhase={this._onAddPhase} />
          <PhaseFooter total={totalBudget} />
        </div>
        <div className='phasefootcont'>{this._renderPhaseToolbar()}</div>
        {this._renderActivitySidebar()}
        {this._renderPoSidebar()}
        {this._renderSidebarColumnOptions()}
      </div>
    )
  }

  _createColumnOptions () {
    return [
      {
        ident: 'sales',
        disabled: false,
        selected: false
      },
      {
        ident: 'budget',
        disabled: false,
        selected: true
      },
      {
        ident: 'spent',
        disabled: false,
        selected: true
      }
    ]
  }

  _onColumnOptions = () => {
    this.setState({ showColumnOptions: true })
  }

  _onGetColumnTitle = column => {
    return `project.budgetContent.column${column
      .charAt(0)
      .toUpperCase()}${column.slice(1)}`
  }

  _onCloseColumnOptions = columns => {
    this.data.pageState.columnOptions = columns
    this.setState({ showColumnOptions: false, dataDate: new Date() })

    this._updatePageState(this.data.pageState)
  }

  _renderConfirmDialog () {
    return (
      <DialogConfirmDelete
        ref={this._references.uploadErrorDialog}
        showOk
        showCancel
        title='plannerv2.task.errorDocTitle'
        subtitle='plannerv2.task.errorDocSubtitle'
        message='plannerv2.task.errorDocMessage'
        onClickOk={this._onClickOk}
      />
    )
  }

  _onConfirmDeleteActivity = itemId => {
    if (this._references.uploadErrorDialog.current) {
      this._references.uploadErrorDialog.current.show()
    }

    this._currentActivityId = itemId
  }

  _onConfirmDeletePhase = (itemId, phase) => {
    if (this._references.uploadErrorDialog.current) {
      this._references.uploadErrorDialog.current.show()
    }

    this._currentPhaseId = itemId
    this._currentPhase = phase
  }

  _onClickOk = () => {
    if (this._references.uploadErrorDialog.current) {
      this._references.uploadErrorDialog.current.hide()
    }

    if (this._currentActivityId) {
      this._onDeleteActivity(this._currentActivityId)
      this._currentActivityId = null
    } else if (this._currentPhaseId) {
      this._onDeletePhase(this._currentPhaseId, this._currentPhase)
      this._currentPhaseId = null
      this._currentPhase = null
    }
  }

  /* Toolbar Functions - START */

  _renderPhaseToolbar () {
    return (
      <PhaseToolbar
        onCreateEstimate={this._onCreateEstimate}
        onCreateInvoice={this._onCreateInvoice}
      />
    )
  }

  _onCreateEstimate = () => {
    const { project } = this.data
    if (project) {
      const estimateData = {
        projectId: project.id,
        contactId: project.contactId,
        isCreateEstimate: true
      }

      app
        .service('/api/project/estimate')
        .create(estimateData)
        .then(estimateRes => {
          if (estimateRes && estimateRes.estimateId) {
            app.changePage('estimate-view', estimateRes.estimateId)
          }
        })
        .catch(err => {
          app.debug('PageprojectViewBudget: _onCreateEstimate Error', err)
        })
    }
  }

  _onCreateInvoice = () => {
    const { project } = this.data
    if (project) {
      const invoiceData = {
        contactId: project.contactId,
        projectId: project.id,
        estimateId: null,
        purchaseOrderId: null,
        type: 'based-on-budget',
        referenceNo: '',
        percentage: 100,
        invoiceDate: null,
        dueDate: null,
        budget: {
          phases: [
            {
              title: '',
              total: 0,
              percentage: 0,
              spentAmount: 0
            }
          ],
          totalSpent: 0,
          total: 0
        }
      }
      const params = {
        query: {
          phaseId: '',
          $client: {
            dateMethod: 'entireProject'
          }
        }
      }

      InvoiceUtil.createInvoice(invoiceData, params, (err, res) => {
        if (err) {
          app.debug('PageprojectViewBudget: _onCreateEstimate Error', err)
        } else {
          app.changePage('invoice-view', res.id)
        }
      })
    }
  }

  /* Toolbar Functions - END */

  isRightSidebarOpen () {
    return !!(this.state.editActivity || this.state.showColumnOptions)
  }

  isSidebarCollapsed () {
    return this.isRightSidebarOpen()
  }

  canShowCollapse () {
    return !this.isRightSidebarOpen()
  }

  _onAddPurchaseOrder = supplier => {
    const { editActivity } = this.state
    if (!editActivity) {
      return null
    }

    const purOrderObj = {
      contactId: supplier.contactId,
      projectId: this.props.projectId,
      description: supplier.title,
      status: 'Draft',
      total: supplier.total,
      invoiceDate: new Date(),
      createdById: app.loggedInId
    }

    app
      .service('/api/purchaseorder')
      .create(purOrderObj)
      .then(purchaseOrderRes => {
        const itemSupplier = _.find(
          editActivity.purchaseOrders,
          ord => ord.supplierId === supplier.supplierId
        )

        if (itemSupplier) {
          itemSupplier.purchaseOrderId = purchaseOrderRes.id
          itemSupplier.poNumber = purchaseOrderRes.invoiceNo
          itemSupplier.totalPoAmount = purchaseOrderRes.total
          itemSupplier.downloadUrl = this._getPurchaseOrderDownloadUrl(
            purchaseOrderRes.id,
            purchaseOrderRes.invoiceNo
          )
          itemSupplier.canDeletePo = true

          this.setState({ editActivity })
        }

        this._getAndShowPurchaseOrderSidebar(purchaseOrderRes.id)
      })
      .catch(createErr => {
        app.debug('PageprojectViewBudget: _onClickAddPO createErr', createErr)
      })
  }

  _getAndShowPurchaseOrderSidebar = purchaseOrderId => {
    const poGetParams = {
      query: {
        $client: {
          subObjects: {
            items: []
          }
        }
      }
    }

    app
      .service('/api/purchaseorder')
      .get(purchaseOrderId, poGetParams)
      .then(poRes => {
        poRes.items = poRes.items || []

        this.setState({ editPurchaseOrder: poRes })
      })
      .catch(err => {
        app.debug('PageprojectViewBudget: _getAndShowPurchaseOrderSidebar', err)
      })
  }

  /* Purchaseorder Functions --- START */

  _renderPoSidebar () {
    const { editPurchaseOrder } = this.state

    if (!editPurchaseOrder) {
      return null
    }

    const downloadUrl = this._getPurchaseOrderDownloadUrl(
      editPurchaseOrder.id,
      editPurchaseOrder.invoiceNo
    )

    return (
      <>
        <SidebarPurchaseOrder
          purchaseOrder={editPurchaseOrder}
          downloadUrl={downloadUrl}
          onClose={this._onCloseSidebarPurchaseOrder}
          onChangeStatus={this._onChangeStatus}
          onChangeItem={this._onChangePurchaseOrderItem}
          onBlurItem={this._onBlurPurchaseOrderItem}
          onKeyDownItem={this._onKeyDownPurchaseOrderItem}
          onChangeIntroText={this._onChangePurchaseOrderIntro}
          onSaveIntroText={this._onSavePurchaseOrderIntro}
          onDelete={this._onDeleteIntro}
          onSendEmail={this._onSendEmail}
          onEdit={this._onEdit}
          onClickEditItem={this._onClickEditPurchaseOrderItem}
          onDeletePoItem={this._onDeletePurchaseOrderItem.bind(this)}
        />
        <DialogMail
          ref={this._references.refdialogMail}
          isLoading={this.state.loading}
          onSubmit={this._onSubmitMail.bind(this)}
          showWithoutContext={this.ident === 'projectview-budgetv2'}
          downloadUrl={downloadUrl}
          showMultiAttachments
        />
        <DialogPurchaseOrderEdit
          ref={this._references.refDialogPurchaseOrderEdit}
          onSubmit={this._onSubmitPurchaseOrderEdit.bind(this)}
          onDelete={this._onDeletePurchaseOrder.bind(this)}
        />
        <DialogInvoiceAddress
          ref={this._references.refDialogInvoiceAddress}
          message='expense.form.contactInfo'
          teamCountry={app.teamCountry}
          onSubmit={this._onSubmitAddressPurchaseOrder.bind(this)}
        />
        <DialogPurchaseOrderOpen
          ref={this._references.refDialogPurchaseOrderOpen}
          onSubmit={this._onSubmitOpen.bind(this)}
          onEditAddress={this._onEditAddress.bind(this)}
        />
        <DialogPurchaseOrderComplete
          ref={this._references.refDialogPurchaseOrderComplete}
          downloadUrl={downloadUrl}
          onMail={this._onMailOpenPo.bind(this)}
        />
      </>
    )
  }

  _recalculatePurchaseOrder () {
    const { editPurchaseOrder } = this.state

    editPurchaseOrder.total = 0
    editPurchaseOrder.items.forEach((poItem, _idx) => {
      editPurchaseOrder.total += parseFloat(poItem.total)
    })

    this.setState({ editPurchaseOrder })

    const updateData = { total: editPurchaseOrder.total }

    app
      .service('/api/purchaseorder')
      .patch(editPurchaseOrder.id, updateData)
      .catch(err => {
        app.debug('PagePurchaseOrderView _recalculatePurchaseOrder err', err)
      })
  }

  _onDeletePurchaseOrder () {
    const { editPurchaseOrder } = this.state
    if (!editPurchaseOrder || !editPurchaseOrder.id) {
      return false
    }

    this._deletePurchaserOrder(editPurchaseOrder.id)
  }

  _deletePurchaserOrder = purchaseOrderId => {
    const { editActivity } = this.state

    app
      .service('/api/purchaseorder')
      .remove(purchaseOrderId)
      .then(_deleteRes => {
        if (this._references.refDialogPurchaseOrderEdit.current) {
          this._references.refDialogPurchaseOrderEdit.current.hide()
        }

        if (editActivity) {
          const itemSupplier = _.find(
            editActivity.purchaseOrders,
            ord => ord.purchaseOrderId === purchaseOrderId
          )

          if (itemSupplier) {
            itemSupplier.purchaseOrderId = ''
            itemSupplier.poNumber = ''
            itemSupplier.totalPoAmount = 0
            itemSupplier.downloadUrl = ''

            this.setState({ editActivity, editPurchaseOrder: null })
          }
        }
      })
      .catch(deleteErr => {
        app.debug('PagePurchaseOrderView _onDeletePurchaseOrder err', deleteErr)
      })
  }

  _onSubmitPurchaseOrderEdit = updateData => {
    const { editPurchaseOrder } = this.state

    app
      .service('/api/purchaseorder')
      .patch(editPurchaseOrder.id, updateData)
      .then(_poEditRes => {
        if (this._references.refDialogPurchaseOrderEdit.current) {
          this._references.refDialogPurchaseOrderEdit.current.hide()
        }
      })
      .catch(estErr => {
        app.debug(
          'PagepurchaseOrderView: _onSubmitPurchaseOrderEdit err',
          estErr
        )
      })
  }

  _getContactPersonOptions (contact) {
    const contactPersonOptions = []
    if (
      contact &&
      contact.contactPersons &&
      contact.contactPersons.length > 0
    ) {
      contact.contactPersons.map(contactPerson => {
        const label =
          contactPerson.name +
          (contactPerson.email ? ' - ' + contactPerson.email : '')
        contactPersonOptions.push({
          label: label,
          value: label,
          obj: contactPerson
        })
      })
    }

    return contactPersonOptions
  }

  _onEdit = () => {
    const { editPurchaseOrder } = this.state

    const contact = editPurchaseOrder.contact
    const contactAddresses =
      editPurchaseOrder && contact && contact.addresses
        ? contact.addresses
        : null
    const params = {}
    const contactPersonOptions = this._getContactPersonOptions(contact)

    if (editPurchaseOrder) {
      app
        .service('/api/contact')
        .get(editPurchaseOrder.contactId, params)
        .then(result => {
          if (result) {
            const purObj = {
              contactLabel: contact ? contact.company : '',
              addressOptions: this._getContactAddressOptions(editPurchaseOrder),
              addresses: contactAddresses,
              contactPersonOptions: contactPersonOptions,
              contactPerson: this._getContactPersonOrDefault(
                editPurchaseOrder,
                contactPersonOptions
              ),
              contactAddress:
                editPurchaseOrder.contactAddress &&
                editPurchaseOrder.contactAddress.type
                  ? editPurchaseOrder.contactAddress
                  : contactAddresses
                    ? contactAddresses[0]
                    : null
            }

            if (this._references.refDialogPurchaseOrderEdit.current) {
              this._references.refDialogPurchaseOrderEdit.current.show(purObj)
            }
          }
        })
        .catch(err => {
          app.debug('PagepurchaseOrderView: _onEdit err', err)
        })
    }
  }

  _getContactPersonOrDefault (invoice, contactPersons) {
    let contactPersonIdent = ''
    if (invoice.contactPerson) {
      contactPersonIdent = `${invoice.contactPerson.name}${
        invoice.contactPerson.email ? ' - ' + invoice.contactPerson.email : ''
      }`
    } else if (contactPersons.length > 0) {
      contactPersonIdent = contactPersons[0].value
    }

    return contactPersonIdent
  }

  _getContactAddressOptions (editPurchaseOrder) {
    const addressOptions = []
    const contact = editPurchaseOrder.contact
    if (contact && contact.addresses && contact.addresses.length > 0) {
      contact.addresses.map(address => {
        const existTypeOption = _.find(
          addressOptions,
          addressOption => addressOption.label === address.type
        )
        const label = IntlUtil.convertMessage(
          `contact.view.type${address.type}`
        )
        if (existTypeOption === undefined) {
          addressOptions.push({
            label: label,
            value: address.type.toLowerCase()
          })
        }
      })
    }

    if (
      editPurchaseOrder.contactAddress &&
      addressOptions[0].value === undefined
    ) {
      const label = IntlUtil.convertMessage(
        `contact.view.type${editPurchaseOrder.contactAddress.type}`
      )
      addressOptions.push({
        label: label,
        value: editPurchaseOrder.contactAddress.type.toLowerCase()
      })
    }

    return addressOptions
  }

  _onSubmitMail (mailObj) {
    app.debug('PagePurchaseOrderView: _onSubmitMail [Start]')
    this.setState({ loading: true })
    const emails = []
    const purchaseOrder = this.state.editPurchaseOrder
    const contactPersons =
      purchaseOrder &&
      purchaseOrder.contact &&
      purchaseOrder.contact.contactPersons &&
      purchaseOrder.contact.contactPersons.length > 0
        ? purchaseOrder.contact.contactPersons
        : []

    if (contactPersons.length > 0) {
      contactPersons.map(contactPerson => {
        if (mailObj.toEmails && mailObj.toEmails.length > 0) {
          mailObj.toEmails.map(mail => {
            if (mail.text === contactPerson.key) {
              emails.push(contactPerson.email)
            }
          })
          _.remove(
            mailObj.toEmails,
            toEmail => toEmail.text === contactPerson.key
          )
        }
      })
    }

    mailObj.toEmails.map(mail => {
      emails.push(mail.text)
    })

    const mailData = {
      toEmails: emails,
      ccEmails: mailObj.ccEmails ? mailObj.ccEmails.map(mail => mail.text) : [],
      subject: mailObj.subject,
      content: mailObj.content,
      files: mailObj.files,
      purchaseorderId: purchaseOrder.id
    }
    const params = { query: {} }

    app.service('/api/purchaseorder/mail').timeout = 30000
    app
      .service('/api/purchaseorder/mail')
      .create(mailData, params)
      .then(_result => {
        if (this._references.refdialogMail.current) {
          this._references.refdialogMail.current.hide()
        }
        this.setState({ loading: false })
      })
      .catch(err => {
        app.debug('PagePurchaseOrderView: _onSubmitMail err', err)
      })
  }

  _onSendEmail = () => {
    const { editPurchaseOrder } = this.state

    const params = { query: {} }
    app
      .service('/api/purchaseorder/mail')
      .get(editPurchaseOrder.id, params)
      .then(emailRes => {
        if (emailRes) {
          if (this._references.refdialogMail.current) {
            this._references.refdialogMail.current.show(emailRes)
          }
        }
      })
      .catch(err => {
        app.debug('PageProjectViewBudgetV2: _onSendMail err', err)
      })
  }

  _onCloseSidebarPurchaseOrder = () => {
    this.setState({ editPurchaseOrder: null })
  }

  _onChangeStatus = () => {
    const status =
      this.state.editPurchaseOrder.status === 'Open' ? 'Closed' : 'Open'

    if (this.state.editPurchaseOrder.status === 'Draft') {
      this._onOpen()
    } else {
      this._updateStatus(status)
    }
  }

  _onOpen () {
    const purchaseorder = this.state.editPurchaseOrder
    const contactPersonOptions = this._getContactPersonOptions(
      purchaseorder.contact
    )

    // Show address dialog if it is incomplete
    if (
      purchaseorder.contactAddress === undefined ||
      (purchaseorder.contactAddress !== undefined &&
        (!purchaseorder.contactAddress.street ||
          !purchaseorder.contactAddress.city ||
          !purchaseorder.contactAddress.postcode))
    ) {
      this.showOpen = true
      const contObj = {
        contactName: purchaseorder.contact.company,
        address: purchaseorder.contactAddress,
        vatNo: purchaseorder.contact.vatNo,
        contactPersonOptions: contactPersonOptions,
        contactPerson: this._getContactPersonOrDefault(
          purchaseorder,
          contactPersonOptions
        )
      }

      if (this._references.refDialogInvoiceAddress.current) {
        this._references.refDialogInvoiceAddress.current.show(contObj, true)
      }
    } else {
      const obj = {
        total: purchaseorder.total,
        contactName: purchaseorder.contact.company,
        addressOptions: this._getContactAddressOptions(purchaseorder),
        addresses:
          purchaseorder &&
          purchaseorder.contact &&
          purchaseorder.contact.addresses
            ? purchaseorder.contact.addresses
            : null,
        contactPersonOptions: contactPersonOptions,
        contactPerson: this._getContactPersonOrDefault(
          purchaseorder,
          contactPersonOptions
        ),
        contactAddress: purchaseorder.contactAddress
          ? purchaseorder.contactAddress
          : ''
      }

      if (this._references.refDialogPurchaseOrderOpen.current) {
        this._references.refDialogPurchaseOrderOpen.current.show(obj)
      }
    }
  }

  _updateStatus (status) {
    const { editPurchaseOrder } = this.state

    app
      .service('/api/purchaseorder')
      .patch(editPurchaseOrder.id, { status: status })
      .then(updateRes => {
        editPurchaseOrder.status = updateRes.status
        this.setState({ dataDate: new Date() })
      })
      .catch(updateErr => {
        app.debug('PageProjectViewBudgetV2 _updateStatus updateErr', updateErr)
      })
  }

  _onSubmitOpen (poObj) {
    const { editPurchaseOrder } = this.state

    app
      .service('/api/purchaseorder')
      .patch(editPurchaseOrder.id, poObj)
      .then(opnRes => {
        editPurchaseOrder.status = poObj.status
        this.setState({ dataDate: new Date() })

        if (this._references.refDialogPurchaseOrderOpen.current) {
          this._references.refDialogPurchaseOrderOpen.current.hide()
        }

        if (this._references.refDialogPurchaseOrderComplete.current) {
          this._references.refDialogPurchaseOrderComplete.current.show(
            opnRes && opnRes.invoiceNo ? opnRes.invoiceNo : ''
          )
        }
      })
      .catch(opnErr => {
        app.debug('PageProjectViewBudgetV2: _onSubmitOpen err', opnErr)
      })
  }

  _onEditAddress (e) {
    e.preventDefault()
    const purchaseorder = this.state.editPurchaseOrder
    const contactPersonOptions = this._getContactPersonOptions(
      purchaseorder.contact
    )

    if (purchaseorder) {
      const contObj = {
        contactName: purchaseorder.contact.company,
        address: purchaseorder.contact.address,
        vatNo: purchaseorder.contact.vatNo,
        contactPersonOptions: contactPersonOptions,
        contactPerson: this._getContactPersonOrDefault(
          purchaseorder,
          contactPersonOptions
        )
      }

      if (this._references.refDialogInvoiceAddress.current) {
        this._references.refDialogInvoiceAddress.current.show(contObj, true)
      }
    }
  }

  _onSubmitAddressPurchaseOrder (updateObj) {
    const purchaseorder = this.state.editPurchaseOrder
    const contactAddresses = []
    let bUpdateExistingCont = false

    if (purchaseorder.contactAddress !== undefined) {
      purchaseorder.contact.addresses.map(address => {
        if (address.type === purchaseorder.contactAddress.type) {
          bUpdateExistingCont = true
          address.street = updateObj.address.street
            ? updateObj.address.street
            : address.street
          address.postcode = updateObj.address.postcode
            ? updateObj.address.postcode
            : address.postcode
          address.city = updateObj.address.city
            ? updateObj.address.city
            : address.city
          address.state = updateObj.address.state
            ? updateObj.address.state
            : address.state
          address.country = updateObj.address.country
            ? updateObj.address.country
            : address.country
          address.type = address.type ? address.type : 'Po'
        }
        contactAddresses.push(address)
      })
    }

    const address = {
      street: updateObj.address.street,
      postcode: updateObj.address.postcode,
      city: updateObj.address.city,
      state: updateObj.address.state,
      country: updateObj.address.country,
      type: updateObj.address.type ? updateObj.address.type : 'Po',
      streetNumber: updateObj.address.streetNumber
    }

    const contObj = {
      company: updateObj.company,
      addresses:
        bUpdateExistingCont && contactAddresses && contactAddresses.length > 0
          ? contactAddresses
          : [address],
      vatNo: updateObj.vatNo
    }

    if (updateObj.contactPersons && updateObj.contactPersons.length > 0) {
      contObj.contactPersons = updateObj.contactPersons
    }

    async.series(
      [
        done => {
          this._updateContactAddresses(contObj, done)
        },
        done => {
          this._updatePurchaseOrderContact(updateObj, done)
        }
      ],
      (err, _res) => {
        if (err) {
          if (this._references.refDialogInvoiceAddress.current) {
            this._references.refDialogInvoiceAddress.current.showError()
          }
          app.debug(
            'PageProjectViewBudgetV2: _onSubmitAddressPurchaseOrder err',
            err
          )
        } else {
          if (this.showOpen) {
            if (this._references.refDialogPurchaseOrderOpen.current) {
              this._references.refDialogPurchaseOrderOpen.current.hide()
            }
            this._getDataPurchaseOrder(_res => {
              this._onOpen()
            })
          } else {
            this.setState({ dataDate: new Date() })
          }

          if (this._references.refDialogInvoiceAddress.current) {
            this._references.refDialogInvoiceAddress.current.hide()
          }
        }
      }
    )
  }

  _onMailOpenPo (_bFullDetails) {
    if (this._references.refDialogPurchaseOrderOpen.current) {
      this._references.refDialogPurchaseOrderOpen.current.hide()
    }

    if (this._references.refDialogPurchaseOrderComplete.current) {
      this._references.refDialogPurchaseOrderComplete.current.hide()
    }

    this._onSendEmail()
  }

  _updateContactAddresses (contactObj, callback) {
    app
      .service('/api/contact')
      .patch(this.state.editPurchaseOrder.contactId, contactObj)
      .then(_contRes => {
        callback(null)
      })
      .catch(contUpdateErr => {
        app.debug(
          'PageProjectViewBudgetV2: _updateContactAddresses err',
          contUpdateErr
        )
        callback(contUpdateErr)
      })
  }

  _updatePurchaseOrderContact (updateObj, callback) {
    const purchaseorderObj = {
      contactAddress: updateObj.address
    }

    if (updateObj.selectedContactPerson) {
      purchaseorderObj.contactPerson = updateObj.selectedContactPerson
    }

    app
      .service('/api/purchaseorder')
      .patch(this.state.editPurchaseOrder.id, purchaseorderObj)
      .then(_decRes => {
        callback(null)
      })
      .catch(estUpdateErr => {
        app.debug(
          'PageProjectViewBudgetV2: _updatePurchaseOrderContactAddresses err',
          estUpdateErr
        )
        callback(estUpdateErr)
      })
  }

  _getDataPurchaseOrder (callback) {
    const params = {
      query: {
        $client: {
          subObjects: {
            contact: ['company', 'addresses', 'contactPersons', 'pdfLanguage'],
            project: ['title'],
            items: []
          }
        }
      }
    }

    app
      .service('/api/purchaseorder')
      .get(this.state.editPurchaseOrder.id, params)
      .then(purOrderRes => {
        if (purOrderRes) {
          this.setState({ editPurchaseOrder: purOrderRes })
        }

        if (
          this.state.editPurchaseOrder &&
          this.state.editPurchaseOrder.contact.contactPersons &&
          this.state.editPurchaseOrder.contact.contactPersons.length > 0
        ) {
          const persons = this.state.editPurchaseOrder.contact.contactPersons
          const tagsData = _.uniqBy(persons, person => person.email)
          const tags = tagsData.map((tagObj, _idx) => {
            let mailOption = `${tagObj.email} (${tagObj.name})`

            if (!tagObj.name) {
              mailOption = `${tagObj.email}`
            }

            tagObj.key = mailOption

            return mailOption
          })

          this.data.emailSuggestions = tags
        }

        callback(null)
      })
      .catch(purOrderErr => {
        app.debug(
          'PageProjectViewBudgetV2: _getDataPurchaseOrder err',
          purOrderErr
        )
        callback(purOrderErr)
      })
  }

  _onChangePurchaseOrderItem = (itemId, name, value) => {
    const { editPurchaseOrder } = this.state
    if (!editPurchaseOrder) {
      return
    }

    const item = _.find(editPurchaseOrder.items, item => item.id === itemId)
    if (!item) {
      return
    }

    item[name] = value
    this.setState({ dataDate: new Date() })
  }

  _onDeletePurchaseOrderItem (itemId) {
    const { editPurchaseOrder } = this.state

    if (!editPurchaseOrder || !itemId) {
      return null
    }

    app
      .service('/api/purchaseorder/item')
      .remove(itemId)
      .then(() => {
        _.remove(editPurchaseOrder.items, item => item.id === itemId)
        this.setState({ editPurchaseOrder })

        this._recalculatePurchaseOrder()
      })
      .catch(err => {
        app.debug(
          'PageProjectViewBudgetV2: _onDeletePurchaseOrderItem err',
          err
        )
      })
  }

  _onClickEditPurchaseOrderItem = (itemId, name) => {
    const { editPurchaseOrder } = this.state
    if (!editPurchaseOrder) {
      return
    }

    const item = _.find(editPurchaseOrder.items, item => item.id === itemId)
    if (!item) {
      return
    }

    item.editable = name
    this.setState({ dataDate: new Date() })
  }

  _onBlurPurchaseOrderItem = (itemId, name) => {
    const { editPurchaseOrder } = this.state
    if (!editPurchaseOrder) {
      return
    }

    const item = _.find(editPurchaseOrder.items, item => item.id === itemId)
    if (!item || !item.id) {
      return
    }

    const updateData = {
      [name]: item[name]
    }

    app.service('/api/purchaseorder/item').patch(itemId, updateData)

    if (name === 'total') {
      this._recalculatePurchaseOrder()
    }
  }

  _onChangePurchaseOrderIntro = (name, value) => {
    const { editPurchaseOrder } = this.state

    if (!editPurchaseOrder) {
      return
    }

    editPurchaseOrder[name] = value
    this.setState({ dataDate: new Date() })
  }

  _onSavePurchaseOrderIntro = name => {
    const { editPurchaseOrder } = this.state

    if (!editPurchaseOrder) {
      return
    }

    const updateData = {
      [name]: editPurchaseOrder[name]
    }

    app.service('/api/purchaseorder').patch(editPurchaseOrder.id, updateData)
  }

  _onDeleteIntro = (name, value) => {
    const { editPurchaseOrder } = this.state

    if (!editPurchaseOrder) {
      return
    }

    const updateData = {
      [name]: value
    }

    app
      .service('/api/purchaseorder')
      .patch(editPurchaseOrder.id, updateData)
      .then(updateRes => {
        editPurchaseOrder[name] = updateRes.introText
        this.setState({ dataDate: new Date() })
      })
      .catch(err => {
        app.debug('PageProjectViewBudgetV2: _onDeleteIntro err', err)
      })
  }

  /* Purchaseorder Functions --- END */

  /* Activity Sidebar */
  _renderActivitySidebar () {
    const { editActivity } = this.state
    if (!editActivity) {
      return null
    }

    const { quickbookItems } = this.data

    return (
      <SidebarActivity
        activity={editActivity}
        suppliers={editActivity.purchaseOrders}
        showLabelType={app.teamCountry === 'US'}
        isQuickbookConnected={app.isQuickbookConnected()}
        quickbookItems={quickbookItems}
        onChangeField={this._onChangeActivityField}
        onSaveField={this._onSaveActivityField}
        onSearchSupplier={BudgetUtil.onSearchSupplier.bind(this)}
        onSelectSupplier={this._onCreateActivitySupplier}
        onDeleteSupplier={this._onDeleteSupplier}
        onAddPurchaseOrder={this._onAddPurchaseOrder}
        onEditPurchaseOrder={this._getAndShowPurchaseOrderSidebar}
        onDeletePurchaseOrder={this._deletePurchaserOrder}
        onCloseActivity={this._onCloseActivity}
        reloadQuickbookItems={this._reloadQuickbookItems}
        onAddSupplier={this._onAddSupplier}
      />
    )
  }

  _renderSidebarColumnOptions () {
    const { showColumnOptions } = this.state
    if (!showColumnOptions) {
      return null
    }

    return (
      <SidebarColumnOptions
        columns={this.data.pageState.columnOptions}
        onClose={this._onCloseColumnOptions}
        onGetTitle={this._onGetColumnTitle}
      />
    )
  }

  _onSaveActivityField = name => {
    const { editActivity } = this.state

    if (!editActivity || !editActivity.id) {
      return
    }

    this._recalculateAndUpdateActivity(editActivity, name)

    this.setState({ editActivity })
  }

  _onCreateActivitySupplier = (supplier, callback = null) => {
    const { editActivity } = this.state

    if (!editActivity || !editActivity.id) {
      return
    }

    const supplierData = {
      contactId: supplier.contactId,
      budgetItemId: editActivity.id,
      projectId: editActivity.projectId,
      purchaseOrderId: supplier.purchaseOrderId
    }

    app
      .service('/api/project/budgetitemsupplier')
      .create(supplierData)
      .then(supplierRes => {
        supplier.id = supplierRes.id
        supplier.supplierId = supplierRes.id

        if (editActivity && editActivity.purchaseOrders) {
          editActivity.purchaseOrders.push(supplier)
        }

        this.setState({ editActivity })

        if (callback) {
          callback()
        }
      })
      .catch(err => {
        app.debug(
          'PageProjectViewBudget::_onCreateActivitySupplier: Error ',
          err
        )
        if (callback) {
          callback()
        }
      })
  }

  _onAddSupplier = (supplierName, callback = null) => {
    this._onCreateContact(supplierName, (_err, contact) => {
      if (contact) {
        this._onAddSupplierFromContact(supplierName, contact.id, callback)
      } else if (callback) {
        callback()
      }
    })
  }

  _onCreateContact (contactName, callback = null) {
    const contactObj = {
      company: contactName,
      addresses: [
        {
          type: 'Office',
          street: '',
          streetNumber: '',
          postcode: '',
          city: '',
          country: app.teamCountry
        }
      ],
      contactPersons: [],
      rateCards: [],
      paymentDays: -1
    }

    app
      .service('/api/contact')
      .create(contactObj)
      .then(contactRes => {
        if (callback) {
          callback(null, contactRes)
        }
      })
      .catch(createErr => {
        app.debug(
          'PageprojectViewBudget: _onClickAddContactErr createErr',
          createErr
        )
        if (callback) {
          callback(createErr, null)
        }
      })
  }

  _onAddSupplierFromContact (keyword, contactId, callback = null) {
    const { editActivity } = this.state
    let excludeIds = []

    if (editActivity.purchaseOrders && editActivity.purchaseOrders.length > 0) {
      excludeIds = editActivity.purchaseOrders.map((obj, _idx) => obj.contactId)
    }

    BudgetUtil.onSearchSupplier(keyword, excludeIds, options => {
      if (options && options.length > 0) {
        const selOpj = _.find(
          options,
          (obj, _idx) => obj.contactId === contactId
        )
        if (selOpj) {
          this._onCreateActivitySupplier(selOpj, callback)
        } else if (callback) {
          callback()
        }
      }
    })
  }

  _onDeleteSupplier = (supplier, callback = null) => {
    const { editActivity } = this.state

    if (!supplier || !supplier.supplierId) {
      return null
    }

    _.remove(
      editActivity.purchaseOrders,
      orderObj => orderObj.supplierId === supplier.supplierId
    )
    this.setState({ editActivity })

    app
      .service('/api/project/budgetitemsupplier')
      .remove(supplier.supplierId)
      .then(() => {
        if (callback) {
          callback()
        }
      })
      .catch(err => {
        app.debug('PageProjectViewBudget::_onDeleteSupplier: Error ', err)
        if (callback) {
          callback()
        }
      })
  }

  _onChangeActivityField = (itemId, name, value) => {
    const item = this._onChangeActivity(itemId, name, value)

    this.setState({ editActivity: item })
  }

  _onCloseActivity = () => {
    this.setState({ editActivity: null })
  }

  _reloadQuickbookItems = () => {
    return app
      .service('/api/quickbook/syncitem')
      .create({})
      .then(itemRes => {
        this.data.quickbookItems = itemRes.data || []
        this.setState({ dataDate: new Date() })
      })
      .catch(err => {
        app.debug('PageprojectViewBudget: _reloadQuickbookItems Error', err)
      })
  }
  /* Activity functions - START */

  _getNextId () {
    return this._nextId--
  }

  _getBudgetItemFromId (itemId) {
    let budgetItem = null
    this.data.budget.phases.forEach(phase => {
      phase.items.forEach(item => {
        if (item.id === itemId) {
          budgetItem = item
        }
      })
    })

    return budgetItem
  }

  _onChangeActivity = (itemId, name, value) => {
    const item = itemId ? this._getBudgetItemFromId(itemId) : null
    if (!item) {
      return
    }

    const numberCols = [
      'noHours',
      'pricePerHour',
      'total',
      'initialBudget',
      'sellingPrice',
      'markupPercentage'
    ]
    if (numberCols.indexOf(name) !== -1) {
      item[name] = value !== '' && !isNaN(value) ? parseFloat(value) : 0
    } else {
      item[name] = value
    }

    if (name !== 'description') {
      item.bInputChanged = true
    }

    this.setState({ dataDate: new Date() })

    return item
  }

  _onSaveActivity = (itemId, name) => {
    const item = itemId ? this._getBudgetItemFromId(itemId) : null
    if (!item) {
      return
    }

    // Hide editable inupt
    item.editable = ''

    if (item.bInputChanged) {
      item.bInputChanged = false
      this._recalculateAndUpdateActivity(item, name)
    }

    this.setState({ dataDate: new Date() })
  }

  _recalculateAndUpdateActivity (item, name, extraFields = []) {
    const updateData = {
      [name]: item[name]
    }

    if (name === 'total') {
      if (item.bInputChanged) {
        calculate.calculateHoursAndRateFromTotal(item)
      }

      updateData.noHours = item.noHours
      updateData.pricePerHour = item.pricePerHour
      updateData.bUseTotal = item.bUseTotal
      updateData.sellingPrice = item.sellingPrice
      updateData.percentage = item.percentage

      if (item.type === 'time-activity') {
        this._calculateSpentFromUserRate(item)
      }
    } else if (name === 'noHours' || name === 'pricePerHour') {
      item.bInputChanged = false
      calculate.calculateTotalFromHoursAndRate(item)

      updateData.total = item.total
      updateData.bUseTotal = item.bUseTotal
      updateData.sellingPrice = item.sellingPrice

      if (item.type === 'time-activity') {
        calculate.calculateSpentAmountFromRate(item)

        updateData.spentAmount = item.spentAmount
        updateData.percentage = item.percentage
      }
    } else if (name === 'sellingPrice') {
      calculate.calculateMarkupFromSellingPrice(item)

      updateData.sellingPrice = item.sellingPrice
      updateData.markupPercentage = item.markupPercentage
    } else if (name === 'markupPercentage') {
      calculate.calculateSellingPriceFromMarkup(item)

      updateData.sellingPrice = item.sellingPrice
      updateData.markupPercentage = item.markupPercentage
    }

    if (extraFields && extraFields.length > 0) {
      extraFields.forEach(extraName => {
        updateData[extraName] = item[extraName]
      })
    }

    // Recalculate budget
    if (
      [
        'sellingPrice',
        'noHours',
        'pricePerHour',
        'total',
        'vat',
        'markupPercentage'
      ].indexOf(name) >= 0
    ) {
      this._recalculateAndUpdateBudget()
    }

    this._updateItemInfo(item, updateData)
  }

  _calculateSpentFromUserRate (item) {
    if (item.type === 'time-activity') {
      const calculateData = {
        projectId: item.projectId,
        budgetItemId: item.id,
        budgetItemTotal: item.total
      }

      app
        .service('/api/project/calculatespent')
        .create(calculateData)
        .then(result => {
          item.spentAmount = result.spentAmount
          item.percentage = result.percentage

          const updateData = {
            spentAmount: result.spentAmount,
            percentage: result.percentage
          }

          this._updateItemInfo(item, updateData)
          this._recalculateAndUpdateBudget()
        })
        .catch(err => {
          app.debug('Budget content: _calculateSpentAmount err', err)
        })
    }
  }

  _recalculateAndUpdateBudget () {
    const { budget } = this.data
    let budgetTotal = 0
    let budgetTotalSpent = 0
    let budgetTotalSelling = 0
    let noActiveTimeActivities = 0

    budget.phases.map(phase => {
      phase.total = 0
      phase.spentAmount = 0
      phase.overSpent = 0
      phase.canDelete = budget.phases.length > 0

      phase.items.map(item => {
        let expenseTotal = 0
        let poTotal = 0

        phase.total += parseFloat(item.total || 0)

        if (item.type === 'expense-activity') {
          budgetTotalSelling += item.sellingPrice
            ? parseFloat(item.sellingPrice)
            : 0
        } else if (item.type === 'time-activity') {
          budgetTotalSelling += parseFloat(item.total || 0)
        }

        if (item.spentAmount) {
          budgetTotalSpent += item.spentAmount
          phase.spentAmount += item.spentAmount
        }

        if (item.purchaseOrders && item.purchaseOrders.length > 0) {
          item.purchaseOrders.map(ord => {
            expenseTotal += ord.expenseTotal
            poTotal += ord.poTotal
          })
        }

        if (item.bUsed) {
          phase.canDelete = false
        }

        item.overSpent = 0
        if (poTotal > item.total) {
          item.overSpent = poTotal - item.total
        } else if (item.spentAmount > item.total) {
          item.overSpent = item.spentAmount - item.total
        } else if (expenseTotal > poTotal) {
          item.overSpent = expenseTotal - poTotal
        }

        phase.overSpent += item.overSpent

        // If phase is active, update the activity count
        if (phase.status === 'active') {
          if (item.type === 'time-activity') {
            noActiveTimeActivities++
          }
        }
      })

      phase.percentage =
        phase.total > 0
          ? calculate.getPercentage(phase.spentAmount, phase.total)
          : 0

      budgetTotal += phase.total
    })

    budget.total = parseFloat(budgetTotal.toFixed(2))
    budget.totalSpent = parseFloat(budgetTotalSpent.toFixed(2))
    budget.totalSellingPrice = parseFloat(budgetTotalSelling).toFixed(2)
    budget.noActiveTimeActivities = noActiveTimeActivities

    this._updateProjectBudget()
  }

  _reorderPhaseItems () {
    const allItems = []
    this.data.budget.phases.map((phase, phaseIdx) => {
      phase.items.map((item, itemIdx) => {
        item.phaseId = phase.id
        item.phaseNo = phaseIdx + 1
        item.groupNo = 1
        item.orderNo = itemIdx + 1
        item.isActive = phase.status === 'active'

        allItems.push(item)
      })
    })

    return Promise.all(
      allItems.map(item => {
        const updateData = {
          isActive: item.isActive,
          phaseNo: item.phaseNo,
          groupNo: item.groupNo,
          orderNo: item.orderNo
        }

        return this._updateItemInfo(item, updateData)
      })
    )
  }

  _onKeyDownActivity = (itemId, name, ev) => {
    const item = itemId ? this._getBudgetItemFromId(itemId) : null
    if (!item) {
      return
    }

    const keyCode = ev.keyCode
    if (
      (keyCode === 9 || (keyCode === 13 && !ev.shiftKey)) &&
      item.bInputChanged
    ) {
      item.bInputChanged = false
      this._recalculateAndUpdateActivity(item, name)
    }

    if (keyCode === 9) {
      item.editable = ''

      let fieldsInOrder = []
      if (item.type === 'time-activity' || item.type === 'expense-activity') {
        if (item.bUseTotal) {
          fieldsInOrder = ['title', 'total']
        } else {
          fieldsInOrder = ['title', 'noHours', 'pricePerHour', 'total']
        }
      }

      const currEditableIdx = fieldsInOrder.indexOf(name)
      let nextEditable = fieldsInOrder[currEditableIdx + 1]

      // If current item has other fields to focus
      if (nextEditable) {
        item.editable = nextEditable
      } else {
        const phase = this.data.budget.phases[item.phaseNo - 1] || null
        if (phase) {
          const currItemIdx = _.findIndex(phase.items, o => o.id === item.id)
          const nextItem =
            currItemIdx !== -1 ? phase.items[currItemIdx + 1] : null

          // If next item exists, make the title as editable
          if (nextItem) {
            nextItem.editable = 'title'
            nextEditable = 'title'
          } else {
            // If next phase is exists, make title of that phase editable
            const nextPhase = this.data.budget.phases[phase.id + 1] || null

            if (nextPhase) {
              nextPhase.editable = 'title'
              nextEditable = 'title'
            }
          }
        }
      }

      if (nextEditable) {
        ev.preventDefault()
      }

      this.setState({ dataDate: new Date() })
    } else if (keyCode === 13 && !ev.shiftKey) {
      ev.preventDefault()

      item.editable = ''

      this._onAddActivity(item.phaseId, item, item.type, true)
      this.setState({ dataDate: new Date() })
    }
  }

  _updateItemInfo (item, updateData) {
    const { project } = this.data
    if (!item.id || !item.title) {
      return
    }

    if (typeof item.id !== 'string' && item.id < 0) {
      const createData = {
        contactId: project.contactId,
        projectId: project.id,
        phaseNo: item.phaseNo,
        groupNo: 1,
        orderNo: item.orderNo,
        type: item.type,
        title: item.title,
        description: item.description,
        total: item.total || 0,
        percentage: 0,
        spentAmount: 0,
        noHours: 0,
        pricePerHour: project.contact.rate
          ? project.contact.rate
          : item.pricePerHour || 0,
        bUseTotal: item.bUseTotal,
        sellingPrice: item.sellingPrice || 0,
        fromDate: 0,
        toDate: 0,
        schedules: [],
        skills: [],
        allcoatedHours: 0
      }

      return app
        .service('/api/project/budgetitem')
        .create(createData)
        .then(createRes => {
          item.id = createRes.id
        })
        .catch(createErr => {
          app.debug('PageProjectViewBudget: _updateItemInfo err', createErr)
        })
    } else {
      return app
        .service('/api/project/budgetitem')
        .patch(item.id, updateData)
        .catch(createErr => {
          app.debug('PageProjectViewBudget: _updateItemInfo err', createErr)
        })
    }
  }

  _onEditActivity = itemId => {
    const item = itemId ? this._getBudgetItemFromId(itemId) : null
    if (!item) {
      return
    }

    this.setState({ editActivity: item })
  }

  _onDeleteActivity = itemId => {
    if (!itemId) {
      return null
    }

    const { budget } = this.data

    budget.phases.forEach(phase => {
      _.remove(phase.items, item => item.id === itemId)
    })

    this.setState({ dataDate: new Date() })

    this._updateProjectBudget(null)

    if (typeof itemId === 'string' && itemId) {
      app
        .service('/api/project/budgetitem')
        .remove(itemId)
        .then(_res => {
          this._recalculateAndUpdateBudget()
        })
        .catch(removeErr => {
          app.debug('PageProjectViewBudget: _onDeleteActivity err', removeErr)
        })
    }
  }

  _onClickEditActivity = (itemId, name) => {
    const item = itemId ? this._getBudgetItemFromId(itemId) : null
    if (!item) {
      return
    }
    item.editable = name

    if (name === 'bUseTotal') {
      item.editable = 'noHours'
      item.bUseTotal = false
    }

    this.setState({ dataDate: new Date() })
  }

  _getItemPosition = itemId => {
    let itemIdx = -1

    this.data.budget.phases.forEach(phase => {
      phase.items.forEach((item, idx) => {
        if (item.id === itemId) {
          itemIdx = idx
        }
      })
    })

    return itemIdx
  }

  _onMoveItem = (oldPhaseId, newPhaseId, overItemId, item, originalIndex) => {
    const { budget } = this.data
    const oldPhaseObj = _.find(budget.phases, obj => obj.id === oldPhaseId)

    const bPageBreak = item.type === 'pagebreak'

    if (oldPhaseId === newPhaseId) {
      // Find index
      const items = oldPhaseObj.items
      const currItemIndex = _.findIndex(items, obj => obj.id === item.id)
      let overItemIndex = originalIndex

      if (overItemId) {
        overItemIndex = _.findIndex(items, obj => obj.id === overItemId)
      }

      // If item is pagebreak
      // If new position is first of phase, or last of phase then dont allow to move item
      const lastItemIdx = items.length - 1
      if (
        bPageBreak &&
        (overItemIndex === 0 || overItemIndex === lastItemIdx)
      ) {
        return
      }

      if (overItemIndex !== currItemIndex) {
        items.splice(currItemIndex, 1)
        items.splice(overItemIndex, 0, item)
      }
    } else {
      const newPhaseObj = _.find(budget.phases, obj => obj.id === newPhaseId)
      if (newPhaseObj) {
        // Find index
        let overItemIndex = originalIndex
        if (overItemId) {
          overItemIndex = _.findIndex(
            newPhaseObj.items,
            obj => obj.id === overItemId
          )
        }

        // If item is pagebreak, and If new position is first of phase, dont allow to move item
        // But new position can be last index, since it is new group
        if (bPageBreak && overItemIndex === 0) {
          return
        }

        item.phaseId = newPhaseId

        _.remove(oldPhaseObj.items, obj => obj.id === item.id)

        if (overItemIndex >= 0) {
          newPhaseObj.items.splice(overItemIndex, 0, item)
        }
      }
    }

    this.setState({ dataDate: new Date() })
  }

  _onSelectRatecard = (itemId, ratecard) => {
    const item = itemId ? this._getBudgetItemFromId(itemId) : null
    if (!item) {
      return
    }

    item.title = ratecard.value
    item.pricePerHour = ratecard.amount
    item.noHours = 0
    item.total = 0
    item.editable = 'noHours'

    this.setState({ dataDate: new Date() })

    this._recalculateAndUpdateActivity(item, 'title', [
      'pricePerHour',
      'noHours',
      'total'
    ])
  }

  _onAddActivity = (phaseId, prevItem, type, bInsertAfter = false) => {
    const { budget, project } = this.data
    const phase = budget.phases[phaseId] || null
    if (!phase) {
      return
    }

    let rateMarkup = 0
    let rate = 0

    if (project && project.contact) {
      rateMarkup = project.contact.rateMarkup
      rate = project.contact.rate
    }

    const newActivity = this._createNewActivity(
      type,
      phase,
      0,
      rateMarkup,
      rate
    )
    newActivity.editable = 'title'

    if (prevItem) {
      let currItemIdx =
        _.findIndex(phase.items, item => item.id === prevItem.id) || 0
      if (bInsertAfter) {
        currItemIdx += 1
      }

      phase.items.splice(currItemIdx, 0, newActivity)

      phase.items.map((item, idx) => {
        item.orderNo = idx + 1
      })
    } else {
      newActivity.orderNo = phase.items.length + 1
      phase.items.push(newActivity)
    }

    this.setState({ dataDate: new Date() })
  }
  /* Activity functions - END */

  /* Phase functions - START */

  _onChangePhase = (phaseId, name, value) => {
    const phase = this.data.budget.phases[phaseId] || null
    if (!phase) {
      return
    }

    phase[name] = value
    this.setState({ dataDate: new Date() })
  }

  _onSavePhase = (phaseId, _name) => {
    const { budget, project } = this.data
    const phase = budget.phases[phaseId] || null
    if (!phase || !project || !project.id) {
      return
    }

    // Hide editable inupt
    phase.editable = ''

    this._updateProjectBudget(null)
  }

  _onClickEditPhase = (phaseId, name, _ev) => {
    const { budget, project } = this.data
    const phase = budget.phases[phaseId] || null
    if (!phase || !project || !project.id) {
      return
    }

    phase.editable = name
    this.setState({ dataDate: new Date() })
  }

  _onKeyDownPhase = (phaseId, name, ev) => {
    const { budget } = this.data
    const phase = budget.phases[phaseId] || null

    if (!phase) {
      return
    }

    if (ev.keyCode === 9) {
      ev.preventDefault()

      phase.editable = ''

      const nextPhase = budget.phases[phaseId + 1] || null

      if (phase.items.length > 0) {
        phase.items[0].editable = 'title'
      } else if (nextPhase) {
        nextPhase.editable = 'title'
      }

      this.setState({ dataDate: new Date() })
    }
  }

  _onDeletePhase = (phaseId, phase) => {
    if (!phaseId) {
      return null
    }

    _.remove(this.data.budget.phases, phaseObj => phaseObj.id === phaseId)

    const removeData = {
      removeItems: [],
      updateItems: [],
      type: 'project'
    }

    // Remove items
    if (phase.items && phase.items.length > 0) {
      phase.items.map(item => {
        removeData.removeItems.push({ id: item.id })
      })
    }

    this.data.budget.phases.map((phase, phaseIdx) => {
      phase.id = phaseIdx
      phase.items.map((item, itemIdx) => {
        item.phaseNo = phaseIdx + 1
        item.orderNo = itemIdx + 1

        removeData.updateItems.push({
          id: item.id,
          data: {
            phaseNo: item.phaseNo,
            groupNo: item.groupNo,
            orderNo: item.orderNo
          }
        })
      })
    })

    this.setState({ dataDate: new Date() })

    this._updateProjectBudget(null)

    app
      .service('/api/common/removephase')
      .create(removeData)
      .then(_res => {
        this._recalculateAndUpdateBudget()
      })
      .catch(removeErr => {
        app.debug('PageProjectViewBudget: _onDeletePhase err', removeErr)
      })
  }

  _onToggleExpand = phaseId => {
    const phase = this.data.budget.phases[phaseId] || null
    if (!phase) {
      return
    }
    phase.isExpand = !phase.isExpand
    this.setState({ dataDate: new Date() })
  }

  _updateProjectBudget (closeDate = null) {
    const { budget, project } = this.data
    const { budget: saveBudgetData } = this._getSaveObject(budget)
    const updateData = {
      budget: saveBudgetData
    }

    if (closeDate) {
      updateData.closeDate = closeDate
    }

    project.budget = saveBudgetData

    return app
      .service('/api/project')
      .patch(project.id, updateData)
      .then(() => {})
      .catch(updateErr => {
        app.debug('PageProjectViewBudget: _updateProjectBudget err', updateErr)
      })
  }

  _onAddPhase = () => {
    const { project } = this.data
    const phases = this.data.budget.phases
    let prevPhase = null
    let fromDate = null
    let toDate = null

    // Next phase duration should start from previous phase toDate only if project has end date
    if (phases.length > 0) {
      prevPhase = phases[phases.length - 1]
    }

    const fromTS = new Date(prevPhase.toDate).getTime()
    const toTS = new Date(project.endDate).getTime()

    if (fromTS <= toTS) {
      fromDate = prevPhase.toDate ? prevPhase.toDate : prevPhase.fromDate
      toDate = project.endDate
    }

    const phase = {
      id: phases.length,
      title: '',
      fromDate: fromDate,
      toDate: toDate,
      status: 'estimate',
      total: 0,
      percentage: 0,
      spentAmount: 0,
      overSpent: 0,
      editable: 'title',
      isExpand: true,
      canDelete: true,
      items: []
    }

    phases.push(phase)
    this.setState({ dataDate: new Date() })

    this._updateProjectBudget(null)
  }

  _onChangePhaseStatus = (phaseId, statusInfo, _closeDate) => {
    const { budget, project } = this.data
    const phase = this.data.budget.phases[phaseId] || null
    if (!phase) {
      return
    }

    if (budget && project.id) {
      phase.status =
        statusInfo.status === 'reopen' ? 'completed' : statusInfo.status

      this.setState({ dataDate: new Date() })

      this._updateProjectBudget(statusInfo.closeDate)
    }
  }

  _onCopyPhase = phaseId => {
    const { budget } = this.data
    const phase = budget.phases[phaseId]

    if (!phase) {
      return
    }

    const copyPhaseData = {
      projectId: this.props.projectId,
      budget: this._getSaveObject(budget, false).budget,
      items: []
    }

    const newPhase = _.cloneDeep(phase)
    newPhase.id = budget.phases.length
    newPhase.status = 'estimate'
    newPhase.spentAmount = 0
    newPhase.title = `${IntlUtil.convertMessage(
      'common.list.copyNewPhasePrefix'
    )} ${newPhase.title || ''}`
    newPhase.canDelete = true

    if (newPhase.items && newPhase.items.length > 0) {
      newPhase.items.map((item, itemIdx) => {
        if (item.title !== '' && item.id) {
          const newItem = this._getSaveItemObject(item, false)
          delete newItem.id

          newItem.phaseNo = newPhase.id + 1
          newItem.orderNo = itemIdx + 1
          newItem.groupNo = 1
          newItem.spentAmount = 0
          newItem.timeSpent = 0
          newItem.schedules = []
          newItem.allcoatedHours = 0
          newItem.percentage = 0
          newItem.isActive = false

          const suppliers = []
          if (item.type === 'expense-activity') {
            if (item.purchaseOrders && item.purchaseOrders.length > 0) {
              item.purchaseOrders.map(purchaseOrderObj => {
                purchaseOrderObj.purchaseOrder = null
                suppliers.push({ contactId: purchaseOrderObj.contactId })
              })
            }
          }

          copyPhaseData.items.push({ data: newItem, suppliers: suppliers })
        }
      })
    }

    app
      .service('/api/project/copyphase')
      .create(copyPhaseData)
      .then(copyRes => {
        const newPhaseData = this._getRenderPhaseObject(
          budget,
          newPhase,
          budget.phases.length,
          copyRes.items
        )
        newPhaseData.editable = 'title'

        budget.phases.push(newPhaseData)

        this._recalculateAndUpdateBudget()

        this.setState({ dataDate: new Date() })
      })
  }

  _onDropItem = (_phaseId, _item) => {
    this._recalculateAndUpdateBudget()
    this._reorderPhaseItems()
  }

  _onMovePhase = (phase, currIndex, overIndex) => {
    if (overIndex !== currIndex) {
      const { budget } = this.data
      budget.phases.splice(currIndex, 1)
      budget.phases.splice(overIndex, 0, phase)

      budget.phases.map((phase, phaseIdx) => {
        phase.id = phaseIdx

        phase.items.map((item, itemIdx) => {
          item.phaseId = phase.id
          item.phaseNo = phaseIdx + 1
          item.groupNo = 1
          item.orderNo = itemIdx + 1
          item.isActive = phase.status === 'active'
        })
      })

      this.setState({ dataDate: new Date() })
    }
  }
  /* Phase functions - END */

  /* Filter functions - START */

  _onChangeFilter = activeFilters => {
    this.data.pageState.activeFilters = activeFilters
    this.setState({ dataDate: new Date() })

    this._updatePageState(this.data.pageState)
  }

  /* Filter functions - END */

  /* Private functions */

  _getBudgetPageQuery () {
    return {
      pageState: this.data.pageState,
      pageIdent: this._pageIdent,
      projectId: this.props.projectId,
      bGetQuickbookItem: app.isQuickbookConnected(),
      project: this._getProjectQuery(),
      budgetItem: {
        projectId: this.props.projectId,
        $sort: { orderNo: 1 },
        $client: {
          getPurchaseOrderClients: true,
          subObjects: {
            bUsed: true
          }
        }
      },
      estimate: {
        projectId: this.props.projectId
      },
      estimateItem: {
        $sort: { orderNo: 1 },
        $client: {
          getPurchaseOrderClients: true
        }
      }
    }
  }

  _getProjectQuery () {
    return {
      $client: {
        subObjects: {
          contact: ['company', 'rateCards', 'rateMarkup', 'rate']
        }
      }
    }
  }

  _getData () {
    this._setDataLoading()

    const params = {
      query: this._getBudgetPageQuery()
    }

    return app
      .service('/api/page/project/budget')
      .find(params)
      .then(result => {
        this._onPageDataRecieved(result.pageData)

        if (result.project) {
          this.data.project = result.project
          this._setProjectToCache(this.data.project)
        }

        if (result.stat) {
          this.data.stat = result.stat
          this._setOverviewStatToCache(this.data.stat)
        }

        this.data.items = result.budgetItems
        this.data.defaultRateCards = result.defaultRateCards
        this.data.quickbookItems = result.quickbookItems || []

        this._onDataReceived(null)
      })
      .catch(err => {
        app.debug('PageProjectViewBudget: _getData ERROR', err)
        this._onDataReceived(err)
      })
  }

  _reloadProjectData () {
    const projectParams = { query: this._getProjectQuery() }
    app
      .service('/api/project')
      .get(this.props.projectId, projectParams)
      .then(project => {
        this.data.project = project
        this._setProjectToCache(project)

        this.setState({ dataDate: new Date() })
      })
      .catch(err => {
        app.debug('PageprojectViewBudget: _reloadProjectData - Error', err)
      })
  }

  _onUserStateRecieved (userState) {
    const pageState = this._getPageUserState(userState)

    if (pageState) {
      this.data.pageState = {
        activeFilters: pageState.activeFilters || []
      }
    }

    if (
      pageState &&
      pageState.columnOptions &&
      pageState.columnOptions.length > 0
    ) {
      this.data.pageState.columnOptions = pageState.columnOptions
      // Make sales enabled
      this.data.pageState.columnOptions.forEach(columnOpt => {
        if (columnOpt.ident === 'sales') {
          columnOpt.disabled = false
        }
      })
    }
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    this._setDataLoaded()

    if (err) {
      app.debug('PageProjectBudget: _onDataReceived Error', err)

      this._setFABButtonVisible(false)
      this.setState({ loading: true, dataDate: new Date() })
    } else {
      app.debug('PageProjectBudget: _onDataReceived [done]')

      // Get the budget phase states and use it
      const userState = this._pageData.userState
      let phaseState = {}
      if (
        userState &&
        userState.state &&
        userState.state.projectPhaseState &&
        userState.state.projectPhaseState[this.data.project.id] !== undefined
      ) {
        phaseState = userState.state.projectPhaseState[this.data.project.id]
      }
      BudgetUtil.setPhaseState(phaseState)

      this.data.budget = this._getRenderObject(
        this.data.project.budget,
        this.data.items
      )

      this.data.rateCards = []
      const rateCards =
        this.data.project.contact && this.data.project.contact.rateCards
          ? this.data.project.contact.rateCards
          : []
      if (rateCards && rateCards.length > 0) {
        rateCards.map(rateCard => {
          const rateCardObj = {
            ...rateCard,
            label: this._formRateCardLabel(rateCard, false),
            value: rateCard.name,
            amount: rateCard.amount,
            labelHasHtml: true
          }

          this.data.rateCards.push(rateCardObj)
        })
      }

      if (this.data.defaultRateCards && this.data.defaultRateCards.length > 0) {
        this.data.defaultRateCards.map(defRateCard => {
          const rateCardObj = {
            ...defRateCard,
            label: this._formRateCardLabel(defRateCard, true),
            value: defRateCard.name,
            amount: defRateCard.amount,
            labelHasHtml: true
          }

          this.data.rateCards.push(rateCardObj)
        })
      }

      const pageState = this.data.pageState
      if (this.data.project.status === 'closed' || pageState.type === 'list') {
        this._setFABButtonVisible(false)
      } else {
        this._setFABButtonVisible(true)
      }

      this.setState({ loading: !this.data.project, dataDate: new Date() })

      app.updatePageTitle(
        'projectview-team',
        this.data.project ? this.data.project.title : ''
      )
      this._triggerEdit()
    }
  }

  _formRateCardLabel (rateCard, bGlobal) {
    return `<span className="label">
        <span className="title">${rateCard.name}</span>
        <span className="type">
          ${
            bGlobal
              ? IntlUtil.convertMessage('project.viewBudget.globalRateCard') +
                ' - '
              : IntlUtil.convertMessage('project.viewBudget.ratecardPrefix') +
                ' - '
          }
          ${currency.formatSymbol(rateCard.amount)} p/u
        </span>
      </span>`
  }

  _triggerEdit () {
    if (this.data.project && this.data.showedit) {
      this.onEditProject()
      this.data.showedit = ''
    }
  }

  _createNewActivity (type, phase, vat, markupPercentage, rate) {
    const { project } = this.data
    const createObj = {
      id: this._getNextId(),
      type: type,
      projectId: project.id,
      contactId: project.contactId,
      title: '',
      description: '',
      total: 0,
      percentage: '',
      spentAmount: 0,
      noHours: '',
      pricePerHour: type === 'time-activity' && rate ? rate : 0,
      fromDate:
        phase.fromDate && phase.fromDate !== undefined ? phase.fromDate : null,
      toDate: phase.toDate && phase.toDate !== undefined ? phase.toDate : null,
      editable: 'title',
      bInputChanged: false,
      phaseId: phase.id,
      phaseNo: phase.id + 1,
      groupNo: 1,
      bUseTotal: false,
      overSpent: 0,
      expenseCount: 0,
      poCount: 0,
      canDelete: true,
      labelType: '',
      initialBudget: -1,
      markupPercentage,
      purchaseOrders: [],
      schedules: []
    }

    return createObj
  }

  /* Render calculations - START */
  _getRenderObject (budget, items) {
    const newBudget = _.cloneDeep(budget || BudgetUtil.createEmptyBudget())

    newBudget.phases.map((phase, phaseIdx) => {
      this._getRenderPhaseObject(newBudget, phase, phaseIdx, items)
    })

    return newBudget
  }

  _getRenderPhaseObject (budget, phase, phaseIdx, items) {
    const phaseState = BudgetUtil.getPhaseState() || {}

    phase.id = phaseIdx
    phase.editable = false
    phase.isExpand =
      phaseState[phaseIdx] !== undefined ? phaseState[phaseIdx] : true
    phase.overSpent = 0
    phase.spentAmount = 0
    phase.percentage = 0
    phase.items = []
    phase.canDelete = budget.phases.length > 0
    phase.sellingPrice = 0

    items.map(item => {
      if (item.phaseNo === phaseIdx + 1) {
        const newItem = _.cloneDeep(item)
        newItem.phaseId = phaseIdx
        newItem.editable = false
        newItem.canDelete = false
        newItem.expenseCount = newItem.expenseCount || 0
        newItem.poCount = newItem.poCount || 0
        newItem.bUsed = newItem.bUsed || false
        newItem.bInputChanged = false

        if (
          !newItem.bUsed &&
          newItem.poCount === 0 &&
          newItem.expenseCount === 0
        ) {
          newItem.canDelete = true
        } else {
          phase.canDelete = false
        }

        if (newItem.purchaseOrders) {
          newItem.purchaseOrders.map(ord => {
            ord.contact = ord.contact ? ord.contact : null
            ord.purchaseOrder = ord.purchaseOrder ? ord.purchaseOrder : null

            if (ord.purchaseOrderId && ord.poNumber) {
              ord.downloadUrl = this._getPurchaseOrderDownloadUrl(
                ord.purchaseOrderId,
                ord.poNumber
              )
            }
          })
        }

        if (newItem.overSpent) {
          phase.overSpent += newItem.overSpent
        }

        if (newItem.type === 'expense-activity') {
          phase.sellingPrice += newItem.sellingPrice
            ? parseFloat(newItem.sellingPrice)
            : 0
        }

        phase.spentAmount += newItem.spentAmount || 0
        phase.percentage = calculate.getPercentage(
          phase.spentAmount,
          phase.total
        )
        phase.items.push(newItem)
      }
    })

    return phase
  }

  _getPurchaseOrderDownloadUrl (purchaseOrderId, poNumber) {
    const baseDownloadUrl = `${routes.PURCHASEORDER_PREVIEW}/${app.getTeamId()}/${app.loggedInId}`
    return encodeURI(`${baseDownloadUrl}/${purchaseOrderId}/${poNumber}.pdf`)
  }

  _getSaveObject (budgetObj, bEstimate) {
    const items = []
    const budget = _.cloneDeep(budgetObj)

    budget.phases.map((phase, phaseIdx) => {
      phase.items.map((item, itemIdx) => {
        const itemObj = this._getSaveItemObject(item, bEstimate)

        itemObj.phaseNo = phaseIdx + 1
        itemObj.groupNo = 0
        itemObj.orderNo = itemIdx + 1
        itemObj.fromDate = itemObj.fromDate ? itemObj.fromDate : null
        itemObj.toDate = itemObj.toDate ? itemObj.toDate : null

        items.push(itemObj)
      })

      delete phase.id
      delete phase.items
      delete phase.editable
      delete phase.isExpand
      delete phase.overSpent
      delete phase.canDelete
      delete phase.orgIndex
      delete phase.sellingPrice
    })

    return { budget, items }
  }

  _getSaveItemObject (item, bEstimate) {
    const saveItemData = _.cloneDeep(item)
    delete saveItemData.phaseId
    delete saveItemData.editable
    delete saveItemData.canDelete
    delete saveItemData.expenseCount
    delete saveItemData.poCount
    delete saveItemData.bUsed
    delete saveItemData.purchaseOrders
    delete saveItemData.contact
    delete saveItemData.overSpent
    delete saveItemData.bInputChanged
    delete saveItemData.orgPhaseId
    delete saveItemData.orgIndex

    if (!bEstimate) {
      delete saveItemData.vat
    } else {
      delete saveItemData.initialBudget
      delete saveItemData.markupPercentage
    }

    return saveItemData
  }
  /* Render calculations - END */

  /* Realtime Events - START */

  _initProjectEvents () {
    this._eventHandlers.projectCreated = this._eventReloadProject.bind(
      this,
      'Project',
      'Created'
    )
    this._eventHandlers.projectUpdated = this._eventReloadProject.bind(
      this,
      'Project',
      'Updated'
    )
    this._eventHandlers.projectRemoved = this._eventReloadProject.bind(
      this,
      'Project',
      'Removed'
    )
    this._eventHandlers.projectPatched = this._eventReloadProject.bind(
      this,
      'Project',
      'Patched'
    )

    const projectService = app.service('/api/project')
    projectService.on('created', this._eventHandlers.projectCreated)
    projectService.on('updated', this._eventHandlers.projectUpdated)
    projectService.on('removed', this._eventHandlers.projectRemoved)
    projectService.on('patched', this._eventHandlers.projectPatched)
  }

  _releaseProjectEvents () {
    const projectService = app.service('/api/project')
    projectService.off('created', this._eventHandlers.projectCreated)
    projectService.off('updated', this._eventHandlers.projectUpdated)
    projectService.off('removed', this._eventHandlers.projectRemoved)
    projectService.off('patched', this._eventHandlers.projectPatched)

    this._eventHandlers.projectCreated = null
    this._eventHandlers.projectUpdated = null
    this._eventHandlers.projectRemoved = null
    this._eventHandlers.projectPatched = null
  }

  _eventReloadProject (objectName, eventName, eventData) {
    if (eventfilters.teamFilter(eventData)) {
      app.debug(
        `-- Event - PageProject budget - ${objectName} - ${eventName} --`
      )
      this._reloadProjectData()
    }
  }

  /* Realtime Events - END */
}

export default PageProjectViewBudgetV2
